import events from '../events/events';

let Tooltip = {}

let _enter;
let _leave;

Tooltip.install = (Vue) =>
{
    Vue.directive('tooltip',
    {
        inserted(el, binding, vnode)
        {
            if ( ! binding || ! binding.value) return;

            // enable to conditionally hide tooltip by using JSON v-tooltip="{text:'abc', visible:false}"
            if (typeof binding.value.visible !== 'undefined' && ! binding.value.visible) return;
            
            let val = typeof binding.value === 'string' ? binding.value : binding.value.text;

            try {
                el.dataset.tooltip = JSON.stringify(val);
            }
            catch(err) {
                el.setAttribute('data-tooltip', JSON.stringify(val));
            }

            _enter = () =>
            {
                let value;
                
                try {
                    value = JSON.parse(el.dataset.tooltip);
                }
                catch(err) {
                    value = JSON.parse(el.getAttribute('data-tooltip'));
                }

                if (value)
                {
                    events.$emit('tooltip.show', {
                        content: value,
                        trigger: el,
                    });
                }
            }

            _leave = () =>
            {
                events.$emit('tooltip.hide');
            }

            el.addEventListener('mouseenter', _enter);
            el.addEventListener('mouseleave', _leave);
        },

        update(el, binding, vnode)
        {
            if ( ! binding || ! binding.value) {
                el.dataset.tooltip = JSON.stringify('');
                return;
            }

            // enable to conditionally hide tooltip by using JSON v-tooltip="{text:'abc', visible:false}"
            if (typeof binding.value.visible !== 'undefined' && ! binding.value.visible) return;
            
            let val = typeof binding.value === 'string' ? binding.value : binding.value.text;

            // update value
            try {
                el.dataset.tooltip = JSON.stringify(val);
            }
            catch(err) {
                el.setAttribute('data-tooltip', JSON.stringify(val));
            }  
        },

        unbind(el, binding, vnode)
        {
            // remove all event listeners
            el.removeEventListener('mouseenter', _enter);
            el.removeEventListener('mouseleave', _leave);
        }
    });
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/js/plugins/tooltip.js